import { tokens } from "@opendoor/tokens-studio/dist/bricks-next/tokens/Components";
import { isKeyOfObject } from "../../../../helpers/utils";
import { useInputState } from "../../shared/hooks";
const { radioCheckbox } = tokens, useCheckBoxRadioState = ({
  disabled,
  errorText,
  invalid,
  onFocus,
  onBlur,
  checked
}) => {
  const { state, handleFocus, handleBlur, setFocused } = useInputState({
    disabled,
    errorText,
    invalid,
    onFocus,
    onBlur
  }), rowState = state || (checked && checked !== "indeterminate" ? "selected" : void 0);
  return { rowState, buttonState: state === "focused" && checked ? "selected" : rowState, handleFocus, handleBlur, setFocused };
}, getCustomRadioCheckboxRowStyling = ({
  size,
  state
}) => {
  const isXSmall = size === "xsmall", disabled = state === "inactive", focused = state === "focused", hoverStyle = disabled ? {} : {
    borderColor: isXSmall ? "$transparent" : radioCheckbox.color.border.row.state.hover,
    backgroundColor: isXSmall ? radioCheckbox.color.background.element.row.state.hover : "$transparent"
  }, focusStyle = focused && !disabled ? {
    borderColor: radioCheckbox.color.border.row.state.focused,
    borderWidth: radioCheckbox.borderWidth.default
  } : {}, cursor = state === "inactive" ? "default" : "pointer", borderColor = isXSmall ? void 0 : isKeyOfObject(state, radioCheckbox.color.border.row.state) ? radioCheckbox.color.border.row.state[state] : radioCheckbox.color.border.row.default;
  return {
    backgroundColor: "$transparent",
    height: isKeyOfObject(size, radioCheckbox.size.rowHeight) ? radioCheckbox.size.rowHeight[size] : 0,
    paddingRight: isKeyOfObject(size, radioCheckbox.padding.leftRight) ? radioCheckbox.padding.leftRight[size] : 0,
    paddingLeft: isKeyOfObject(size, radioCheckbox.padding.leftRight) ? radioCheckbox.padding.leftRight[size] : 0,
    borderRadius: isKeyOfObject(size, radioCheckbox.cornerRadius.row) ? radioCheckbox.cornerRadius.row[size] : 0,
    borderWidth: radioCheckbox.borderWidth.default,
    // hides the border if it's xsmall
    borderColor: borderColor || "$transparent",
    hoverStyle,
    focusStyle,
    cursor
  };
};
export {
  getCustomRadioCheckboxRowStyling,
  useCheckBoxRadioState
};
